export default __webpack_public_path__ + "static/media/NeueHaasUnicaW02-Bold.bad37c2f.eot";